import React from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import { FlexContainerTopCard } from "./gwpatcarea.styled"

const GwpAtcTopCard = ({ data }) => {
  const { heading, copy, containerClasses, image, button } = data

  return (
    <FlexContainerTopCard className={containerClasses || "justify-start"}>
      <Box className="img-box rounded-sm">
        <img src={image} alt={``} role="presentation" className="rounded-sm" />
      </Box>
      <Box>
        <TextElementNova
          element="h4"
          text={heading}
          className="Body-20-Dia-Strong"
        />
        <TextElementNova
          text={copy}
          className="Body-10-Dia-Normal text-nova-transparency-black-70"
        />
        {button ? (
          <ButtonNova
            label={button.label}
            icon={button.icon}
            level={button.level}
          />
        ) : null}
      </Box>
    </FlexContainerTopCard>
  )
}

export default GwpAtcTopCard
